module.exports = __webpack_public_path__ + "static/media/menu.a45269fd.png";